import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './core/styles/scrollbar.css';
import './core/styles/ui-design.css';
import './core/styles/global-dropdowns.css';
import './App.css';
import App from './App';
import './i18n';
import './online-demo/bootstrapCloudDemoStorage';
import { logAppMode } from './shared/utils/browserMode';
import { logApiConfig } from './shared/utils/apiConfig';
import { register as registerServiceWorker, unregister as unregisterServiceWorker } from './shared/utils/serviceWorkerRegistration';
import { checkAndUpdateSchema } from './shared/utils/updateDatabaseSchema';
import { initializeTheme } from './core/utils/globalTheme';
import { isSaudiBrand } from './products/saudi/utils/isSaudiBrand';
import { applySaudiBrandRuntime } from './products/saudi/utils/applySaudiBrandRuntime';

if (isSaudiBrand()) {
  require('./products/saudi/layout/saudi-qawaem.css');
}

// DISABLE ALL CONSOLE LOGS IN PRODUCTION (FOR EXE USERS)
if (process.env.NODE_ENV === 'production') {
  console.log = () => {};
  console.warn = () => {};
  console.info = () => {};
  console.debug = () => {};
  // Keep console.error for critical debugging only
}

// Log current application mode (browser or electron)
logAppMode();

// Log API configuration
logApiConfig();

// 🎨 Initialize global theme system FIRST
initializeTheme();

if (isSaudiBrand()) {
  applySaudiBrandRuntime();
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// PWA only for cloud demo — Qawaem web app is a normal website
if (isSaudiBrand()) {
  void unregisterServiceWorker();
} else {
  registerServiceWorker();
}

// Update database schema if needed
checkAndUpdateSchema();
